import { createAsyncThunk } from '@reduxjs/toolkit';
import { getCustomFormsService } from '../services/customFormsServices';

export const getCustomFormsThunk = createAsyncThunk(
  'customForms/getCustomForms',
  async (payload, { getState, rejectWithValue }) => {
    try {
      const response = await getCustomFormsService();

      return response;
    } catch (error) {
      return rejectWithValue('Failed to add NEW UNIT data');
    }
  }
);
